<template>
  <v-app-bar class="" app color="white">
   <v-app-bar-nav-icon  @click.prevent="toggleLeftBar()"></v-app-bar-nav-icon>
      <v-toolbar-title class="text-xs-right">
        {{ navHeading }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading pr-3"><span class="color--grey">Welcome</span> {{ userName }}</v-toolbar-title>

      <v-menu
        :close-on-content-click="true"
        :nudge-bottom="50"
        :nudge-left="50"
        :nudge-width="100"
        attach
        max-height="400"
        class="top-nav-select-business text-left"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" depressed v-bind="attrs" v-on="on">
           <i class="fas fa-user-circle"></i> &nbsp; {{ userSelectedAccount.name }} 
          </v-btn>
        </template>

         <v-card>
         <v-list>
          <template  v-for="(account, index) in userAccounts">
             <v-list-item :color="userSelectedAccount.id === account.id ? 'primary': ''" v-bind:key="index" ripple  @click="switchAccount(account)">
              <v-list-item-action v-if="userSelectedAccount.id === account.id">
                <v-icon color="primary">done</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ account.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-bind:key="`${index}_accounts`" v-if="userAccounts.length > index + 1"></v-divider>
           </template>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item @click="logout()">
            <v-list-item-action>
              <v-icon light>exit_to_app</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      </v-menu>
    <v-btn icon @click.stop="toggleRightBar()">
      <v-icon>more_vert</v-icon>
    </v-btn>
   </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AuthApis from '@/components/Controllers/AuthApis';
import Env from '@/env';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import AuthApi from '@/components/Controllers/AuthApis';

export default {
  data() {
    return {
    };
  },
  computed: {
    userSelectedAccount() {
      return this.$store.getters.getLoggedInUserSelectedAccount;
    },
    userAccounts() {
      return this.$store.getters.getLoggedInUserAccounts;
    },
    navHeading() {
      return this.$route.meta.pageTitle;
    },
    userName() {
      return `${this.$store.getters.getLoggedInUser.first_name} ${this.$store.getters.getLoggedInUser.last_name}`;
    },
    ...mapGetters({
      rightBarStatus: 'navigation/rightNavStatus',
      leftBarStatus: 'navigation/leftNavStatus',
    }),
  },
  mounted() {
 
  },
  methods: {
    /**
     * Switch Account
     */
    switchAccount(obj) {
      const self = this;
      if (this.$store.getters.getLoggedInUserSelectedAccount.id === obj.id) {
        this.snackbar({
          text: 'You are currently loggedin.',
          timeout: 4000,
          open: true,
        });
        return false;
      }
  
      this.$swal({
        title: 'Swicth Account?',
        type: 'warning',
        allowOutsideClick: false,
        html:
          'You are switching business accounts.',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: '#333',
        cancelButtonColor: '#f14409',
        confirmButtonText: 'CONTINUE',
        cancelButtonText: 'CANCEL',
      }).then((result) => {
        // Need to restart session account login 
        if (result.value) {
          self.spinner(true);
          /**
           *  Keep backup token account id and accounts then clean it all then assion only these having backup
           * */
          const backup = {
            token: self.$store.getters.getLoggedInUserToken,
            step: 'at_completed',
            user: self.$store.getters.getLoggedInUser,
            userAccounts: self.$store.getters.getLoggedInUserAccounts,
          };
          self.$store.dispatch('SET_USER_DATA_EMPTY', '');
            
          // Then assign the initials
          self.$store.dispatch('SET_USER_LOGIN_STEP', backup.step);
          self.$store.dispatch('SET_USER_TOKEN', backup.token);
          self.$store.dispatch('SET_USER_DETAILS', backup.user);
          self.$store.dispatch('SET_USER_ACCOUNTS', backup.userAccounts);
          self.$store.dispatch('SET_USER_SELECTED_ACCOUNT', obj);
          this.getBusinessBranding();
          AuthApi.setActiveBusiness(obj.id).then((res) => {
            self.spinner(false);
            if(this.$route.name != "Applications"){
              self.$router.push({ name: 'Applications' });
            }
            // If we are switching
            if(this.$route.name === 'Applications' ){
              self.fetchApps();
            }
            
            self.$swal(
              'Success',
              'Account successfully switched.',
              'success',
            );
       
          })
          .catch(err => {
            self.spinner(false);
            alert('Error switching account.');
          })
        
        }
      });
    },

    fetchApps() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}/apps`;
      AuthApi.getApi(url)
        .then((res) => {
          this.setAppList(res.data.payload);
        })
        .catch(() => {
          console.log('error getting applications')
        });
    },

  /**
   * ON swtch account chnage branding
   */
    getBusinessBranding() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}`;
      AuthApi.getApi(url)
        .then((res) => {
          
          this.$store.dispatch('SET_USER_SELECTED_ACCOUNT_BRANDING', res.data.payload.branding);  
          this.$vuetify.theme.themes.light.primary = this.$store.getters.getLoggedInUserSelectedBusinessBrandingPrimary;
          this.$vuetify.theme.themes.light.secondary = this.$store.getters.getLoggedInUserSelectedBusinessBrandingSecondary;
          this.$vuetify.theme.themes.light.accent =  this.$store.getters.getLoggedInUserSelectedBusinessBrandingAccent;
          
        })
        .catch(err => {
          console.log( err)
        })
    },

    /**
     * Open / close left siderbar menu
     */
    toggleLeftBar() {
      this.leftBar(!this.leftBarStatus);
    },
    /**
     * Open close right bar
     */
    toggleRightBar() {
      /**
       * This ection is to get locations
       */
      const self = this;
      this.rightBar(true);
    },
  
    /**
     * Clear user storage and throw back to login screen
     */
    logout() {
      /**
       * Clear storage
       */
      this.spinner(true);
      const url = `${Env.url}/api/v1/users/logout`;
      AuthApis.postApi(url)
        .then((response) => {
      
          // On successful logout
          this.$store.dispatch('SET_USER_DATA_EMPTY', '');
          this.$router.push({ name: 'Login' });
          this.snackbar({
            text: response.data.msg,
            timeout: 5000,
            open: true,
          });
          this.spinner(false);

          this.$vuetify.theme.themes.light.primary = this.$store.getters.getLoggedInUserSelectedBusinessBrandingPrimary;
          this.$vuetify.theme.themes.light.secondary = this.$store.getters.getLoggedInUserSelectedBusinessBrandingSecondary;
          this.$vuetify.theme.themes.light.accent = this.$store.getters.getLoggedInUserSelectedBusinessBrandingAccent;
       
        })
        .catch((err) => {
          this.$store.dispatch('SET_USER_DATA_EMPTY', '');
          this.$router.push({ name: 'Login' });
          this.snackbar({
            text: 'Error occured, please try again later.',
            timeout: 5000,
            open: true,
          });
          this.spinner(false);
          this.$vuetify.theme.themes.light.primary = this.$store.getters.getLoggedInUserSelectedBusinessBrandingPrimary;
          this.$vuetify.theme.themes.light.secondary = this.$store.getters.getLoggedInUserSelectedBusinessBrandingSecondary;
          this.$vuetify.theme.themes.light.accent = this.$store.getters.getLoggedInUserSelectedBusinessBrandingAccent;
        });
    },
    ...mapActions({
      setAppList: 'application/setList',
      leftBar: 'navigation/leftNavStatus',
      rightBar: 'navigation/rightNavStatus',
      snackbar: 'snackbar/snackbar',
      spinner: 'spinner/spinnerStatus',
    }),
  },
};
</script>
